/* Dynoforce autokiezer
   20-10-2026 (laatste autokeuze wint): een zelf gekozen auto die niet bij
   het onthouden kenteken hoort, wist dat kenteken; een nieuw kenteken maakt
   de auto van dat kenteken de gekozen auto (dat deed volgKenteken al). Alle
   weergave leest de gekozen auto via de regel in de header (window.DFKeuze)
   en loopt mee op df:auto. Luuk: kenteken ingevuld, daarna "Jouw auto" zelf
   op een Tesla gezet, en op een Tesla-product stond nog "Jouw auto:
   Volkswagen Golf 2013".
   20-10-2026 (ronde 3, spoor thema, punt 6): Engels "licence plate" (Brits,
   EU-markt) in plaats van "license plate" in alle zichtbare teksten.
   20-10-2026 (ronde 4, spoor thema, punt 7): df_auto bewaart het pad zonder
   taal- of marktvoorvoegsel (kaal); het voorvoegsel komt er bij het tonen
   bij via Shopify.routes.root (lokaal). Een geheugen met /en-eu/ erin wordt
   bij het lezen kaal gemaakt en zo teruggeschreven.
   Bedient het paneel achter "Kies je auto" in de menubalk en onthoudt de
   gekozen auto. De lijst met auto's staat als JSON in de header en wordt
   in Liquid opgebouwd uit elke collectie met een gevuld metaveld
   dynoforce.modelgroep, dus een nieuwe modelcollectie verschijnt vanzelf.

   Let op: assets/df-header.js is een gebouwd bestand en bevat nog de oude
   finder. Die stapt er zelf uit omdat hij .finder zoekt en het paneel nu
   .dfauto heet. Het openklappen zat in datzelfde blok, dus dat doen we hier.
*/
(function () {
  'use strict';

  var SLEUTEL = 'df_auto';
  var MERK_EERST = ['BMW', 'Audi', 'Volkswagen', 'Mercedes-Benz'];

  /* Engels (11-10-2026). Op /en-eu/ stonden de uitkomst van het kenteken,
     de chiptuningkaart en de regel "Je auto" in het Nederlands. De taal
     staat op het html-element; op een Nederlandse pagina verandert er
     niets. Het vermogen heet in het Engels hp in plaats van pk. */
  var EN = /^en/i.test(document.documentElement.lang || '');
  function T(nl, en) { return EN ? en : nl; }
  function eenheid(e) {
    var eh = e || 'pk';
    return EN && /^pk$/i.test(eh) ? 'hp' : eh;
  }
  /* Foutteksten uit de datalaag (df-data.js), die alleen Nederlands kent. */
  var FOUTEN_EN = {
    'Vul een volledig kenteken in.': 'Enter a complete licence plate.',
    'Het duurt langer dan normaal. Probeer het nog een keer, of bel 0525-796515.': 'This is taking longer than usual. Try again, or call 0525-796515.',
    'De kentekenservice reageert niet. Probeer het zo nog een keer.': 'The licence plate service is not responding. Please try again shortly.'
  };
  var MERK_ALIAS = { vw: 'volkswagen', mercedes: 'mercedesbenz', mercedesamg: 'mercedesbenz' };

  function plat(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, '');
  }
  function merkSleutel(s) {
    var k = plat(s);
    return MERK_ALIAS[k] || k;
  }
  function woorden(s) {
    return ' ' + String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
  }

  /* Ronde 4, punt 7: de url altijd kaal lezen en kaal bewaren. */
  function lees() {
    try {
      var r = localStorage.getItem(SLEUTEL);
      var a = r ? JSON.parse(r) : null;
      if (a && typeof a.url === 'string') a.url = kaal(a.url);
      return a;
    } catch (e) { return null; }
  }
  function bewaar(a) {
    if (a && typeof a.url === 'string') a.url = kaal(a.url);
    try { localStorage.setItem(SLEUTEL, JSON.stringify(a)); } catch (e) {}
  }

  /* Het onthouden kenteken. Schrijven doet de datalaag bij elke opvraging
     (assets/df-data.js, sleutel df_kenteken, vorm { kt, v, ts }); hier wordt
     alleen gelezen. Het kenteken vult overal de velden voor in; het volledige
     antwoord (v) laat de rekenkaarten direct tekenen. Na dertig dagen telt hij
     niet meer mee. */
  /* Het taalvoorvoegsel (/en-eu) hoort niet in het geheugen df_auto, wel in
     elke link die we zetten (EN-1, 17-10-2026). Op de Nederlandse site is
     de wortel '/' en verandert er niets. */
  function lokaal(u) {
    var w = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!u || w === '/' || u.charAt(0) !== '/' || u.charAt(1) === '/') return u;
    var kop = w.replace(/\/$/, '');
    if (u === kop || u.indexOf(kop + '/') === 0) return u;
    return kop + u;
  }

  /* Ronde 4, punt 7 (20-10-2026): het pad zonder taal- of marktvoorvoegsel.
     Op /en-eu/ geeft Shopify de collectie-url mét /en-eu terug, en wie daar
     een auto koos kreeg op de Nederlandse site links naar de Engelse. Een
     eerste padstuk als /en-eu, /en of /nl-be is altijd een voorvoegsel: de
     eigen paden (/collections, /products, /pages ...) zijn langer. */
  function kaal(u) {
    if (!u || typeof u !== 'string' || u.charAt(0) !== '/' || u.charAt(1) === '/') return u;
    var m = u.match(/^\/[a-z]{2}(?:-[a-z0-9]{2,4})?(?=\/|\?|#|$)/i);
    if (m) u = u.slice(m[0].length) || '/';
    if (u.charAt(0) !== '/') u = '/' + u;
    return u;
  }

  /* Een oud geheugen met voorvoegsel meteen kaal terugschrijven, zodat ook
     de andere scripts die df_auto lezen (categorieen, meer carbon) op de
     Nederlandse site geen Engelse link meer maken. */
  try {
    var ruwAuto = localStorage.getItem(SLEUTEL);
    var oudAuto = ruwAuto ? JSON.parse(ruwAuto) : null;
    if (oudAuto && typeof oudAuto.url === 'string' && kaal(oudAuto.url) !== oudAuto.url) bewaar(oudAuto);
  } catch (e) { /* geen opslag of kapot geheugen: laat maar */ }

  var KT_SLEUTEL = 'df_kenteken';
  var KT_HOUDBAAR = 30 * 24 * 60 * 60 * 1000;

  function ktLees() {
    /* De datalaag houdt dit bij en kan terugvallen op sessionStorage als de
       browser localStorage weigert; daarom eerst daar vragen. */
    if (window.DFData && window.DFData.onthoudenKenteken) {
      return window.DFData.onthoudenKenteken();
    }
    /* 20-10-2026, laatste autokeuze wint: zonder datalaag dezelfde regel. */
    if (window.DFKeuze && window.DFKeuze.nu) return window.DFKeuze.nu().kenteken;
    try {
      var r = JSON.parse(localStorage.getItem(KT_SLEUTEL) || 'null');
      if (!r || !r.kt || !r.ts || Date.now() - r.ts > KT_HOUDBAAR) return null;
      return r;
    } catch (e) { return null; }
  }

  /* ---- kenteken volgen binnen de pagina ----
     Elke opvraging loopt via de datalaag en die roept hem om met df:kenteken.
     Alle platen op deze pagina schrijven zich dan bij, ook die van een andere
     sectie: wie in de hero zoekt ziet hetzelfde kenteken in het menupaneel
     staan. En komt de pagina terug uit het geheugen van de browser - de
     terugknop - dan draaien de scripts niet opnieuw, dus vullen we daar
     alsnog de lege velden voor. */
  function alleVelden() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-df-kt-input],[data-dfa-kt-input]'));
  }

  function vulPlaten(kt, alleenLege) {
    if (!kt) return;
    var net = (window.DFData && window.DFData.formatPlate) ? window.DFData.formatPlate(kt) : kt;
    alleVelden().forEach(function (veld) {
      if (veld === document.activeElement) return;
      /* Staat er al iets anders in, dan is de bezoeker aan het typen: afblijven. */
      if (alleenLege && veld.value && veld.value !== net) return;
      veld.value = net;
      /* Merkje: dit heeft de bezoeker niet zelf ingetikt. Zie hieronder. */
      veld.setAttribute('data-df-voorin', '');
    });
  }

  /* Een vooringevuld kenteken staat op de maxlengte van het veld: acht tekens
     met de streepjes mee. Wie er dan in klikt en gewoon begint te typen ziet
     niets gebeuren, want er kan geen teken meer bij - dat leest als een kapot
     veld. Daarom selecteren we de tekst zodra iemand een voorgevuld veld
     aanraakt: het eerste teken vervangt hem dan in een keer. Het merkje gaat
     eraf zodra de bezoeker zelf iets typt.

     Zowel op focusin als op click, en met een tel wachten: de browser zet de
     cursor pas na de focus, en die klik zou de selectie meteen weer opheffen. */
  function kiesAlles(veld) {
    if (!veld || !veld.hasAttribute || !veld.hasAttribute('data-df-voorin')) return;
    setTimeout(function () {
      if (veld !== document.activeElement) return;
      try { veld.select(); } catch (e) { /* oudere browser */ }
    }, 0);
  }

  function isPlaat(el) {
    return !!(el && el.hasAttribute &&
              (el.hasAttribute('data-df-kt-input') || el.hasAttribute('data-dfa-kt-input')));
  }

  if (!window.__dfKtVolgt) {
    window.__dfKtVolgt = true;
    document.addEventListener('focusin', function (e) {
      if (isPlaat(e.target)) kiesAlles(e.target);
    });
    document.addEventListener('click', function (e) {
      if (isPlaat(e.target)) kiesAlles(e.target);
    });
    document.addEventListener('input', function (e) {
      if (isPlaat(e.target)) e.target.removeAttribute('data-df-voorin');
    });
    document.addEventListener('df:kenteken', function (e) {
      vulPlaten(e && e.detail ? e.detail.kt : '', false);
    });
    window.addEventListener('pageshow', function (e) {
      if (!e || !e.persisted) return;
      var r = ktLees();
      if (r) vulPlaten(r.kt, true);
    });
    /* 20-10-2026, laatste autokeuze wint. Verandert de keuze terwijl de
       pagina openstaat (een ander tabblad, de terugknop, een kenteken of
       auto elders op de pagina), dan mag een plaat die wij hebben
       voorgevuld niet het kenteken van de oude keuze blijven tonen. Wat de
       bezoeker zelf typte blijft staan. */
    document.addEventListener('df:auto', function () {
      var r = ktLees();
      var net = r ? ((window.DFData && window.DFData.formatPlate) ? window.DFData.formatPlate(r.kt) : r.kt) : '';
      alleVelden().forEach(function (veld) {
        if (veld === document.activeElement) return;
        if (veld.hasAttribute('data-df-voorin')) {
          if (veld.value === net) return;
          veld.value = net;
          if (!net) veld.removeAttribute('data-df-voorin');
        } else if (!veld.value && net) {
          veld.value = net;
          veld.setAttribute('data-df-voorin', '');
        }
      });
    });

    /* En bij het openen van de pagina alle nog lege platen voorinvullen. Twee
       secties regelen hun kenteken zelf en komen dus niet langs de gewone weg:
       de motorkiezer op de Bootmod3-pagina en de tunekiezer. Alleen invullen,
       niet opzoeken - dat kost de dienst niets en de bezoeker houdt de knop. */
    var vulLege = function () {
      var r = ktLees();
      if (r) vulPlaten(r.kt, true);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', vulLege);
    } else {
      vulLege();
    }
  }

  /* Jaarbereik uit een label als "G20 / G21 (2018-2022)", "G80 M3 Sedan (2021+)"
     of "VW Golf 8.5 (2024-heden)". Chassiscodes als F06 of 8.5Y bevatten ook
     cijfers, dus alleen 19xx en 20xx tellen mee. Zonder jaartal geen bereik. */
  function bereik(label) {
    var t = String(label || '');
    var jaren = (t.match(/(?:19|20)\d{2}/g) || []).map(Number);
    if (!jaren.length) return null;
    var open = t.indexOf('+') !== -1 || t.toLowerCase().indexOf('heden') !== -1 || jaren.length === 1;
    return { start: jaren[0], eind: open ? 9999 : jaren[jaren.length - 1], open: open };
  }

  /* De modelnaam uit een label, los van de chassiscode. Twee generaties van
     dezelfde auto krijgen zo dezelfde naam: "F85 X5 M" en "F95 X5 M" worden
     allebei "x5 m", terwijl "G05 X5" in diezelfde groep gewoon "x5" blijft.
     Wat een chassiscode is en wat een modelnaam, leest hij af aan de groep:
     "X5 / X5 M" noemt x5 en m, dus die twee blijven staan en F95 valt af.
     Blijft er niets over, dan is de code zelf de naam - een G42 is nergens
     anders mee te verwarren. LCI hoort bij dezelfde auto en telt dus niet
     mee. Naast de lijn komen ook los de woorden terug die echte modelnaam
     zijn; daar wordt verderop mee gewogen. */
  function labelWoorden(label, groep) {
    var d = String(label || '').split('(')[0].toLowerCase().match(/[a-z0-9.]+/g) || [];
    var gt = String(groep || '').toLowerCase().match(/[a-z0-9.]+/g) || [];
    d = d.filter(function (x) { return x !== 'lci'; });
    function code(x) {
      return gt.indexOf(x) === -1 && /\d/.test(x) &&
             /^[a-z]{0,2}\d{1,3}(\.\d)?[a-z]{0,2}$/.test(x);
    }
    var naam = d.filter(function (x) { return !code(x); });
    while (d.length > 1 && code(d[0])) d.shift();
    while (d.length > 1 && code(d[d.length - 1])) d.pop();
    return { lijn: d.join(' '), naam: naam };
  }

  /* Welke generaties passen bij een bouwjaar. Een open bereik loopt door tot
     het startjaar van de eerstvolgende generatie van dezelfde modellijn,
     anders zou "G80 M3 (2021+)" ook een auto uit 2024 opslokken die inmiddels
     een eigen generatie heeft. Alleen dezelfde lijn telt mee: in "X5 / X5 M"
     staan twee auto's naast elkaar, en de X5 LCI van 2023 is geen opvolger
     van de X5 M uit 2019 - die liep daar gewoon door. Zonder dat onderscheid
     verdween elke X5 M, X6 M, X4, X1 en M3 Sedan van na 2022 uit beeld. */
  function opJaar(rijen, jaar) {
    if (rijen.length === 1) return rijen.slice();
    if (jaar == null) return [];
    var ontleed = rijen.map(function (r) {
      return { r: r, b: bereik(r.l), n: labelWoorden(r.l, r.g).lijn };
    });
    var raak = [];
    ontleed.forEach(function (o) {
      if (!o.b) return;
      var eind = o.b.eind;
      if (o.b.open) {
        ontleed.forEach(function (a) {
          if (a === o || !a.b || a.n !== o.n) return;
          if (a.b.start > o.b.start) eind = Math.min(eind, a.b.start - 1);
        });
      }
      if (o.b.start <= jaar && jaar <= eind) raak.push(o.r);
    });
    return raak;
  }

  /* Alle manieren waarop het register een modelnaam kan opschrijven. Het
     schrijft letters en cijfers nogal eens los van elkaar ("RS 3 Sportback"
     bij een RS3), dus naast de losse woorden telt elk aan elkaar geplakt paar
     buurwoorden mee: "rs"+"3" wordt "rs3". En andersom: een X3 M staat er als
     "X3M", dus knippen we een aaneengeschreven naam ook weer bij de cijfers
     los. Zonder dat laatste kwam een X3 M of X4 M nergens uit. */
  function ruimte(model) {
    var los = woorden(model).trim().split(' ').filter(Boolean);
    var uit = los.slice();
    for (var p = 0; p < los.length - 1; p++) uit.push(los[p] + los[p + 1]);
    los.forEach(function (w) {
      var stuk = w.match(/\d+|[a-z]+/g) || [];
      if (stuk.length < 2) return;
      for (var i = 0; i < stuk.length; i++) {
        uit.push(stuk[i]);
        if (i < stuk.length - 1) uit.push(stuk[i] + stuk[i + 1]);
      }
    });
    return uit;
  }

  /* Raakt het model uit de kentekenopvraging deze modelgroep? De groep wordt
     op de schuine streep gesplitst, dus "A5 / S5 / RS5" vangt "A5 Coupe".
     Delen van een letter slaan we over: de R uit "Golf / GTI / R" zou anders
     op elk model met een losse R passen. */
  function groepRaakt(groep, model) {
    var m = ' ' + ruimte(model).join(' ') + ' ';
    var delen = String(groep || '').split('/');
    for (var i = 0; i < delen.length; i++) {
      var d = woorden(delen[i]).trim();
      if (d.length < 2) continue;
      if (m.indexOf(' ' + d + ' ') !== -1) return true;
    }
    return false;
  }

  /* Passen er meerdere generaties bij het bouwjaar, dan wint de modellijn die
     het meest van de naam terugziet: bij "X5 M Competition" noemt "F95 X5 M"
     zowel de X5 als de M, en "G05 X5 LCI" alleen de X5. Elk woord uit de lijn
     dat er niet in staat telt af, zodat een gewone X5 juist bij de X5 uitkomt
     en niet bij de X5 M. Een lijn zonder modelnaam - "G42" - telt nul en doet
     dus niet mee in de weging. Alleen wegstrepen als er echt een koploper is;
     staat het gelijk, dan blijft de hele lijst staan en kiest de bezoeker. */
  function weeg(lijst, namen) {
    if (lijst.length < 2) return lijst;
    var woordjes = [];
    namen.forEach(function (n) { woordjes = woordjes.concat(ruimte(n)); });
    var m = ' ' + woordjes.filter(Boolean).join(' ') + ' ';
    var punten = lijst.map(function (it) {
      var p = 0;
      labelWoorden(it.l, it.g).naam.forEach(function (w) {
        p += m.indexOf(' ' + w + ' ') !== -1 ? 1 : -1;
      });
      return p;
    });
    var hoog = Math.max.apply(null, punten);
    if (hoog === Math.min.apply(null, punten)) return lijst;
    return lijst.filter(function (it, i) { return punten[i] === hoog; });
  }

  function opMerk(a, b) {
    var ia = MERK_EERST.indexOf(a), ib = MERK_EERST.indexOf(b);
    if (ia !== -1 || ib !== -1) {
      if (ia === -1) return 1;
      if (ib === -1) return -1;
      return ia - ib;
    }
    return a.localeCompare(b, undefined, { numeric: true });
  }
  function opStart(a, b) {
    var ba = bereik(a.l), bb = bereik(b.l);
    var va = ba ? ba.start : 9999, vb = bb ? bb.start : 9999;
    if (va !== vb) return va - vb;
    return String(a.l).localeCompare(String(b.l), undefined, { numeric: true });
  }

  function start() {
    var paneel = document.getElementById('autokiezer');
    var hdr = document.querySelector('.hdr');
    var tog = hdr ? hdr.querySelector('.ftog') : null;
    if (!paneel || !hdr || !tog) return;

    var bron = paneel.querySelector('[data-dfa-autos]');
    var rijen = [];
    try { rijen = JSON.parse(bron.textContent) || []; } catch (e) { rijen = []; }

    /* merk -> modelgroep -> [{l:label, u:url}] */
    var boom = {};
    rijen.forEach(function (r) {
      if (!boom[r.m]) boom[r.m] = {};
      if (!boom[r.m][r.g]) boom[r.m][r.g] = [];
      boom[r.m][r.g].push({ l: r.l, u: r.u, m: r.m, g: r.g });
    });

    var sMerk = paneel.querySelector('[data-dfa="merk"]');
    var sModel = paneel.querySelector('[data-dfa="model"]');
    var sGen = paneel.querySelector('[data-dfa="gen"]');
    var knop = paneel.querySelector('[data-dfa="go"]');
    var uit = paneel.querySelector('[data-dfa-uit]');
    var veld = paneel.querySelector('[data-dfa-kt-input]');
    if (!sMerk || !sModel || !sGen || !knop) return;

    /* ---- openklappen ---- */
    tog.addEventListener('click', function (e) {
      e.preventDefault();
      var open = hdr.classList.toggle('fopen');
      tog.setAttribute('aria-expanded', String(open));
      if (open) {
        hdr.classList.remove('open', 'zoekopen');
        if (veld) { try { veld.focus(); } catch (er) {} }
      }
    });

    /* Klik op de waas sluit het paneel. De waas is een ::before van het
       paneel zelf (zie df-header), dus zo'n klik komt binnen als klik op het
       paneelelement. Alleen sluiten als de klik buiten de paneelrand valt:
       een klik op de rand of de vulling van het paneel zelf is geen sluiten. */
    paneel.addEventListener('click', function (e) {
      if (e.target !== paneel) return;
      var r = paneel.getBoundingClientRect();
      if (e.clientY > r.bottom || e.clientY < r.top || e.clientX < r.left || e.clientX > r.right) {
        hdr.classList.remove('fopen');
        tog.setAttribute('aria-expanded', 'false');
      }
    });

    /* ---- keuzelijsten ---- */
    function leeg(sel) {
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = '';
      o.textContent = sel.getAttribute('data-leeg') || T('Kies', 'Choose');
      sel.appendChild(o);
      sel.disabled = true;
    }
    function vul(sel, items) {
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = '';
      o.textContent = sel.getAttribute('data-leeg') || T('Kies', 'Choose');
      sel.appendChild(o);
      items.forEach(function (it) {
        var e = document.createElement('option');
        e.value = it.waarde;
        e.textContent = it.tekst;
        sel.appendChild(e);
      });
      sel.disabled = false;
    }

    var merken = Object.keys(boom).sort(opMerk);
    vul(sMerk, merken.map(function (m) { return { waarde: m, tekst: m }; }));
    leeg(sModel);
    leeg(sGen);
    knop.disabled = true;

    sMerk.addEventListener('change', function () {
      leeg(sModel); leeg(sGen); knop.disabled = true;
      if (!sMerk.value || !boom[sMerk.value]) return;
      var groepen = Object.keys(boom[sMerk.value]).sort(function (a, b) {
        return a.localeCompare(b, undefined, { numeric: true });
      });
      vul(sModel, groepen.map(function (g) { return { waarde: g, tekst: g }; }));
      if (groepen.length === 1) {
        sModel.value = groepen[0];
        sModel.dispatchEvent(new Event('change'));
      }
    });

    sModel.addEventListener('change', function () {
      leeg(sGen); knop.disabled = true;
      if (!sModel.value) return;
      var items = boom[sMerk.value][sModel.value].slice().sort(opStart);
      vul(sGen, items.map(function (it) { return { waarde: it.u, tekst: it.l }; }));
      if (items.length === 1) {
        sGen.value = items[0].u;
        sGen.dispatchEvent(new Event('change'));
      }
    });

    sGen.addEventListener('change', function () {
      knop.disabled = !sGen.value;
    });

    /* ---- laatste autokeuze wint (20-10-2026) ----
       gekozen(): de gekozen auto volgens de regel in de header, dus niet een
       keuze die bij een ouder kenteken hoort. ruwKt(): het kenteken zoals het
       bewaard staat, ook als het door een zelf gekozen auto vervangen is. */
    function gekozen() {
      /* Herstel na review (20-10-2026): de keuze zoals de regel hem geeft,
         dus ook zonder een verlopen kenteken erin. */
      if (window.DFKeuze && window.DFKeuze.nu) {
        var n = window.DFKeuze.nu().auto;
        if (n && typeof n.url === 'string') n.url = kaal(n.url);
        return n;
      }
      return lees();
    }
    /* Het kenteken uit het adres, alleen als dat nog een verse keuze is
       (zie uitLink in de header, 20-10-2026, laatste autokeuze wint). */
    function ktUitAdres() {
      if (window.DFKeuze && window.DFKeuze.uitLink) return window.DFKeuze.uitLink();
      try { return new URLSearchParams(window.location.search).get('kenteken') || ''; } catch (e) { return ''; }
    }
    function ruwKt() {
      if (window.DFKeuze && window.DFKeuze.ruwKenteken) return window.DFKeuze.ruwKenteken();
      return ktLees();
    }
    function ktPlat(kt) { return String(kt || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
    /* Valt deze collectie onder de herkenning? Bij een zeker antwoord de ene
       generatie, bij een groep (meerdere generaties, of geen bouwjaar) elk
       van die generaties. */
    function passend(url, res) {
      if (!url || !res) return false;
      if (res.niveau === 'zeker' && res.item) return kaal(res.item.u) === kaal(url);
      if (res.niveau === 'groep' && res.items) {
        for (var i = 0; i < res.items.length; i++) { if (kaal(res.items[i].u) === kaal(url)) return true; }
      }
      return false;
    }
    /* Hoort een zelf gekozen collectie bij het onthouden kenteken? Dan blijft
       het kenteken gelden: dezelfde auto, maar nu met de generatie erbij. */
    function hoortBij(url, k) {
      var v = k && (k.v || k.auto);
      if (!v || (!v.merk && !v.model)) return false;
      return passend(url, herken(v));
    }
    function vergeet() {
      if (window.DFData && window.DFData.vergeetKenteken) { window.DFData.vergeetKenteken(); return; }
      try { localStorage.removeItem(KT_SLEUTEL); } catch (e) {}
      try { sessionStorage.removeItem(KT_SLEUTEL); } catch (e) {}
      try { sessionStorage.removeItem('df_kt_laatste'); } catch (e) {}
    }
    /* Roept df:auto om; alles wat de auto toont (menu, chip, Jouw auto, meer
       carbon, categorieen, formulieren) tekent zich daarop opnieuw. */
    function meld() {
      if (window.DFKeuze && window.DFKeuze.meld) { window.DFKeuze.meld(); return; }
      try { document.dispatchEvent(new CustomEvent('df:auto', { detail: { auto: gekozen(), kenteken: ktLees() } })); } catch (e) {}
    }

    /* Het kenteken gaat alleen mee als de keuze uit de kentekenuitkomst komt.
       Wie eerst een kenteken intikt en daarna toch handmatig een andere auto
       kiest, zou anders een kenteken bij de verkeerde auto opslaan, en dat
       kenteken reist mee naar de chiptuningpagina. */
    /* 20-10-2026, laatste autokeuze wint: een zelf gekozen auto die niet bij
       het onthouden kenteken hoort, wist dat kenteken; hoort hij er wel bij
       (dezelfde auto, bijvoorbeeld na meerdere uitvoeringen), dan krijgt de
       keuze het kenteken mee. */
    function kiesUrl(url, kenteken) {
      var raak = null;
      rijen.forEach(function (r) { if (r.u === url) raak = r; });
      if (!raak) return;
      var auto = { merk: raak.m, groep: raak.g, label: raak.l, url: raak.u };
      var k = ruwKt();
      if (kenteken) auto.kenteken = kenteken;
      else if (k && hoortBij(raak.u, k)) auto.kenteken = window.DFData && window.DFData.formatPlate ? window.DFData.formatPlate(k.kt) : k.kt;
      bewaar(auto);
      if (k && ktPlat(auto.kenteken) !== ktPlat(k.kt)) vergeet();
      meld();
      window.location.href = lokaal(raak.u);
    }

    knop.addEventListener('click', function () {
      if (!sGen.value) return;
      kiesUrl(sGen.value, '');
    });

    function zetVoor(merk, groep, url) {
      if (merk && boom[merk]) { sMerk.value = merk; sMerk.dispatchEvent(new Event('change')); }
      if (groep) {
        for (var i = 0; i < sModel.options.length; i++) {
          if (sModel.options[i].value === groep) { sModel.value = groep; sModel.dispatchEvent(new Event('change')); break; }
        }
      }
      if (url) {
        /* Ronde 4, punt 7: de opties hebben op /en-eu/ het voorvoegsel, het
           geheugen niet; daarom kaal vergelijken. */
        for (var j = 0; j < sGen.options.length; j++) {
          if (kaal(sGen.options[j].value) === kaal(url)) { sGen.value = sGen.options[j].value; sGen.dispatchEvent(new Event('change')); break; }
        }
      }
    }

    /* ---- uitkomst van het kenteken ---- */
    function toon(doel, html, kenteken) {
      if (!doel) return;
      doel.innerHTML = html;
      doel.hidden = false;
      doel.classList.add('on');
      Array.prototype.forEach.call(doel.querySelectorAll('[data-dfa-url]'), function (b) {
        b.addEventListener('click', function () { kiesUrl(b.getAttribute('data-dfa-url'), kenteken); });
      });
      var zelf = doel.querySelector('[data-dfa-zelf]');
      if (zelf) {
        zelf.addEventListener('click', function () {
          /* In het menupaneel spring je naar de eerste keuzelijst. Staat de
             uitkomst ergens anders, bijvoorbeeld in de kop van de shop, dan
             staan die lijsten daar niet en klapt het paneel open. */
          if (paneel.contains(doel)) {
            try { sMerk.focus(); } catch (e) {}
          } else {
            if (!hdr.classList.contains('fopen')) tog.click();
            try { sMerk.focus(); } catch (e) {}
          }
        });
      }
    }
    function veilig(s) {
      var d = document.createElement('div');
      d.textContent = String(s == null ? '' : s);
      return d.innerHTML;
    }
    function knopjes(items) {
      return items.map(function (it) {
        return '<button type="button" class="dfa__opt" data-dfa-url="' + veilig(it.u) + '">' + veilig(it.l) + '</button>';
      }).join('');
    }

    /* De chiptuningkaart rechts in de uitkomst. De kentekenopvraging levert
       naast merk en model ook de Stage 1-cijfers, dus die winst laten we
       meteen zien met een knop naar de chiptuningpagina. Het kenteken reist
       mee in de link; die pagina leest hem uit het adres en rekent dan
       vanzelf door. Alleen bij een enkelvoudig antwoord: bij meerdere
       uitvoeringen verschilt de winst per motor en gokken we niet. */
    function tuneKaart(v, kenteken) {
      if (!v || !v.vermogen) return '';
      if (typeof v.vermogen.origineel !== 'number' || typeof v.vermogen.stage1 !== 'number') return '';
      var e = eenheid(v.vermogen.eenheid);
      var kt = kenteken ? '?kenteken=' + encodeURIComponent(kenteken) : '';
      /* Met het taalvoorvoegsel, zodat de Engelse bezoeker op de Engelse
         chiptuningpagina uitkomt; in het Nederlands is dat gewoon /. */
      var wortel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return '<a class="dfa__tune" href="' + wortel + 'pages/chiptuning' + kt + '">' +
             '<em>' + T('Chiptuning Stage 1', 'Stage 1 ECU tuning') + '</em>' +
             '<b>' + v.vermogen.origineel + ' &rarr; ' + v.vermogen.stage1 + ' ' + veilig(e) + '</b>' +
             '<span>' + T('Bekijk chiptuning', 'View ECU tuning') + '</span></a>';
    }

    /* De opvraging noemt het model niet altijd bij de naam. Bij 1-XKB-99 staat
       er "318D" bovenaan, terwijl de uitvoeringen eronder gewoon "3 serie GT"
       en "X1" zeggen. Daarom kijken we naar alle modelnamen die het antwoord
       bevat en niet alleen naar de bovenste. */
    function modelnamen(v) {
      var uit = [];
      function voegtoe(s) {
        if (!s) return;
        if (uit.indexOf(s) === -1) uit.push(s);
      }
      voegtoe(v && v.model);
      if (v && v.uitvoeringen && v.uitvoeringen.length) {
        v.uitvoeringen.forEach(function (u) { voegtoe(u && u.model); });
      }
      return uit;
    }

    function herken(v) {
      var mk = merkSleutel(v && v.merk);
      var merk = null;
      merken.forEach(function (m) { if (merkSleutel(m) === mk) merk = m; });
      if (!merk) return { niveau: 'onbekend' };

      var namen = modelnamen(v);
      var groepen = Object.keys(boom[merk]).filter(function (g) {
        for (var i = 0; i < namen.length; i++) {
          if (groepRaakt(g, namen[i])) return true;
        }
        return false;
      });
      if (!groepen.length) return { niveau: 'merk', merk: merk };

      var jaar = parseInt(v && v.bouwjaar, 10);
      if (isNaN(jaar)) jaar = null;

      /* Per groep eerst op bouwjaar filteren, daarna alles samenvoegen. Zo
         valt bij een kenteken dat op twee modellen past de helft vanzelf af,
         want een generatie die er in dat jaar nog niet was telt niet mee. */
      var raak = [];
      var alles = [];
      groepen.forEach(function (g) {
        var items = boom[merk][g].slice().sort(opStart);
        alles = alles.concat(items);
        raak = raak.concat(opJaar(items, jaar));
      });

      /* Wegen op modelnaam, maar alleen binnen wat het bouwjaar overliet. Valt
         er geen enkel bouwjaar te raken, dan komt de hele groep in beeld en
         weten we te weinig om iets weg te strepen. */
      raak = weeg(raak, namen);

      if (raak.length === 1) {
        return { niveau: 'zeker', merk: merk, groep: raak[0].g, item: raak[0] };
      }
      var lijst = raak.length ? raak : alles;
      var eengroep = true;
      for (var i = 1; i < lijst.length; i++) {
        if (lijst[i].g !== lijst[0].g) { eengroep = false; break; }
      }
      return {
        niveau: 'groep',
        merk: merk,
        groep: eengroep && lijst.length ? lijst[0].g : null,
        items: lijst.slice().sort(opStart)
      };
    }

    /* Haakje voor df-kenteken.js (10-10-2026). De knop "Passende onderdelen"
       in de resultaatkaart van de homepagina hoort rechtstreeks op de
       modelcollectie uit te komen, met precies deze herkenning: de boom en
       de weging zitten in deze functie opgesloten, dus we geven de
       herkenning als geheel door. Het antwoord van de opvraging gaat erin,
       niveau/merk/groep/item komen eruit. */
    window.DFAuto = window.DFAuto || {};
    window.DFAuto.herken = herken;

    function teken(doel, res, v, kenteken) {
      var zelfknop = '<button type="button" class="dfa__zelf" data-dfa-zelf>' + T('Klopt niet? Kies zelf', 'Not right? Choose it yourself') + '</button>';
      var tune = tuneKaart(v, kenteken);
      var inner;
      if (res.niveau === 'zeker') {
        inner = '<p class="dfa__kop">' + T('Wij denken: ', 'We think: ') + veilig(res.merk + ' ' + res.groep) + '</p>' +
                '<div class="dfa__opts">' + knopjes([res.item]) + '</div>' + zelfknop;
        zetVoor(res.merk, res.groep, res.item.u);
      } else if (res.niveau === 'groep') {
        var wie = res.groep ? res.merk + ' ' + res.groep : res.merk;
        inner = '<p class="dfa__kop">' + T('We herkennen je ', 'We recognize your ') + veilig(wie) + T('. Welke is het?', '. Which one is it?') + '</p>' +
                '<div class="dfa__opts">' + knopjes(res.items) + '</div>';
        zetVoor(res.merk, res.groep, null);
      } else if (res.niveau === 'merk') {
        inner = '<p class="dfa__kop">' + T('We herkennen je ', 'We recognize your ') + veilig(res.merk) +
                T(', maar het model konden we er niet bij vinden.', ", but we couldn't find the model.") + '</p>' +
                '<p class="dfa__reg">' + T('Kies je model zelf, of app ons en we zoeken met je mee.', "Choose your model yourself, or message us and we'll help you look.") + '</p>' + zelfknop;
        zetVoor(res.merk, null, null);
      } else {
        var naam = [v && v.merk, v && v.model].filter(Boolean).join(' ');
        inner = EN
          ? '<p class="dfa__kop">We don\'t have a fixed list for ' + (naam ? veilig(naam) : 'this car') + ' yet.</p>' +
            '<p class="dfa__reg">Choose a car yourself, or message us and we\'ll check what\'s available.</p>' + zelfknop
          : '<p class="dfa__kop">Voor ' + (naam ? veilig(naam) : 'deze auto') + ' hebben we nog geen vaste lijst.</p>' +
            '<p class="dfa__reg">Kies zelf een auto, of app ons en we kijken wat er leverbaar is.</p>' + zelfknop;
      }
      toon(doel, '<div class="dfa__hoofd">' + inner + '</div>' + tune, kenteken);
    }

    /* ---- kenteken opvragen ----
       Elke plaat op de pagina wordt gebonden, dus zowel die in het menupaneel
       als die in de kop van de shop. De uitkomst gaat naar het dichtstbijzijnde
       blok met data-dfa-uit; heeft de sectie er geen, dan valt hij terug op het
       paneel. De plaat in de kop draagt daarom hetzelfde kenmerk dfa-kt, want
       hij hoort bij dezelfde vraag: welke auto heb je. */
    function bindPlaat(vorm) {
      if (!window.DFData || vorm.dataset.dfaInit) return;
      vorm.dataset.dfaInit = '1';
      var eigenVeld = vorm.querySelector('[data-dfa-kt-input]');
      var stand = vorm.querySelector('[data-dfa-kt-status]');
      if (!eigenVeld) return;
      var sectie = vorm.closest('.shopify-section') || document;

      /* Sitebreed onthouden: het veld voorinvullen met het laatste kenteken. */
      var onthouden = ktLees();
      if (onthouden && !eigenVeld.value) {
        eigenVeld.value = window.DFData.formatPlate(onthouden.kt);
      }

      /* Op de shop-kop is het veld dubbelop zodra de auto bekend is: de chip
         in de filterbalk zegt daar hetzelfde. Dan een compacte regel met de
         naam, de knop naar de onderdelen en een weggetje terug naar het veld.
         In het menupaneel blijft de plaat gewoon staan: die zie je alleen als
         je het paneel opent, en daar staat de wisregel al. */
      /* 20-10-2026, laatste autokeuze wint: gekozen() in plaats van lees(),
         en de regel staat in een functie zodat hij op df:auto opnieuw kan. */
      var gekozenAuto = gekozen();
      /* Komt de bezoeker binnen met een kenteken in de link dat niet bij de
         gekozen auto hoort, dan hoort hier niet "Je auto" met die oude auto
         te staan, maar de plaat met de uitkomst van dit kenteken eronder.
         (16-10-2026, Luuk: kenteken op home, "Passende onderdelen", en op de
         collectiepagina stond nog de auto van een eerdere keuze.) De gekozen
         auto zelf volgt het kenteken, zie volgKenteken() onderaan. */
      var ktInLink = '';
      if (!paneel.contains(vorm)) {
        try { ktInLink = window.DFData.formatPlate(ktUitAdres()); } catch (e) { ktInLink = ''; }
      }
      if (gekozenAuto && ktInLink && gekozenAuto.kenteken !== ktInLink) gekozenAuto = null;
      var mijn = null;
      /* Staat hier de regel "Je auto" (en niet de plaat omdat de bezoeker
         daarvoor koos)? Dan volgt hij elke nieuwe keuze, ook als er tijdens
         een opvraging even geen auto is. */
      var metRegel = false;
      function zetMijn(gekozenAuto) {
        if (mijn && mijn.parentNode) mijn.parentNode.removeChild(mijn);
        mijn = null;
        if (!(gekozenAuto && gekozenAuto.url && gekozenAuto.label)) { vorm.hidden = false; return; }
        var mijnNaam = gekozenAuto.merk ? gekozenAuto.merk + ' ' + gekozenAuto.label : gekozenAuto.label;
        mijn = document.createElement('div');
        mijn.className = 'dfa__mijn';
        var mijnKop = document.createElement('em');
        mijnKop.textContent = T('Je auto', 'Your car');
        mijn.appendChild(mijnKop);
        var mijnVet = document.createElement('b');
        mijnVet.textContent = mijnNaam;
        mijn.appendChild(mijnVet);
        var mijnKnop = document.createElement('a');
        mijnKnop.className = 'btn btn-red dfa__mijn-knop';
        mijnKnop.href = lokaal(gekozenAuto.url);
        mijnKnop.textContent = T('Bekijk onderdelen', 'View parts');
        if (window.location.pathname === lokaal(gekozenAuto.url)) {
          mijnKnop.setAttribute('aria-current', 'page');
        }
        mijn.appendChild(mijnKnop);
        var mijnAnder = document.createElement('button');
        mijnAnder.type = 'button';
        mijnAnder.className = 'dfa__mijn-ander';
        mijnAnder.textContent = T('ander kenteken', 'different licence plate');
        mijnAnder.addEventListener('click', function () {
          if (mijn && mijn.parentNode) mijn.parentNode.removeChild(mijn);
          mijn = null;
          metRegel = false;
          vorm.hidden = false;
          try { eigenVeld.focus(); } catch (e) {}
        });
        mijn.appendChild(mijnAnder);
        vorm.hidden = true;
        vorm.parentNode.insertBefore(mijn, vorm);
      }
      if (gekozenAuto && gekozenAuto.url && gekozenAuto.label && !paneel.contains(vorm)) { zetMijn(gekozenAuto); metRegel = true; }
      /* Op df:auto alleen een bestaande regel bijwerken of weghalen, nooit
         er een bij zetten waar de plaat stond: na "Passende onderdelen"
         hoort de bezoeker de plaat met de uitkomst te blijven zien. */
      /* Herstel na review (20-10-2026): het kenteken uit de link telt alleen
         bij het laden; een latere keuze (ook in een ander tabblad) wint. */
      vorm.__dfaMijn = function () {
        if (!metRegel) return;
        zetMijn(gekozen());
      };
      var doel = sectie.querySelector('[data-dfa-uit]') || uit;
      var zoekknop = vorm.querySelector('[type="submit"]');
      var plaat = vorm.querySelector('.df-kt');
      var bezig = false;

      /* Het laadteken. Het licht dat over de plaat trekt zit al kant en klaar
         in assets/df-base.css onder .df-kt.scan, met een eigen regel voor wie
         bewegingen liever beperkt houdt. Die klasse werd hier alleen nooit
         gezet, waardoor er tijdens het zoeken niets gebeurde. */
      function aanDeSlag(ja) {
        if (plaat) plaat.classList.toggle('scan', ja);
        if (zoekknop) zoekknop.disabled = ja;
        if (!stand) return;
        stand.classList.toggle('bezig', ja);
        if (ja) {
          stand.textContent = T('We zoeken je auto op', 'Looking up your car');
          stand.classList.add('on');
        }
      }

      eigenVeld.addEventListener('input', function () {
        eigenVeld.value = window.DFData.formatPlate(eigenVeld.value);
      });

      vorm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (bezig) return;
        var kt = eigenVeld.value.trim();
        if (!kt) { eigenVeld.focus(); return; }
        bezig = true;
        if (doel) doel.hidden = true;
        aanDeSlag(true);
        window.DFData.lookupPlate(kt).then(function (v) {
          bezig = false;
          aanDeSlag(false);
          if (stand) { stand.textContent = ''; stand.classList.remove('on'); }
          /* Onthouden voor de rest van de site gebeurt in de datalaag, bij de
             opvraging zelf (assets/df-data.js). Daar komt elke plaat op de
             site langs, dus ook de motorkiezer met zijn eigen afhandeling. */
          /* Voor onderdelen is merk, model en bouwjaar genoeg. Ook bij status
             "meerdere" staan die er gewoon in; dat gaat alleen over motoren
             en dat is een vraag voor chiptuning, niet voor carbon. */
          if (!v || (!v.merk && !v.model)) {
            teken(doel, { niveau: 'onbekend' }, v, eigenVeld.value);
            return;
          }
          teken(doel, herken(v), v, eigenVeld.value);
        }).catch(function (err) {
          bezig = false;
          aanDeSlag(false);
          var foutZin = err && err.message ? err.message : '';
          if (EN) foutZin = FOUTEN_EN[foutZin] || foutZin || "That didn't work.";
          else if (!foutZin) foutZin = 'Dat lukte niet.';
          if (stand) { stand.textContent = foutZin; stand.classList.add('on'); }
        });
      });

      /* Binnengekomen met een kenteken in de link, bijvoorbeeld via de knop
         "Passende onderdelen" op de homepagina (10-10-2026)? Dan meteen
         opzoeken, zodat de bezoeker de herkende auto ziet zonder nog een
         keer op de knop te drukken. Alleen op de plaat in de kop van de
         shop, een keer per pagina, en niet als het veld schuilgaat achter
         de regel "Je auto". Het antwoord komt uit het geheugen van de
         datalaag, dus binnen dezelfde sessie kost dit geen opvraging. */
      if (!paneel.contains(vorm) && !vorm.hidden && !window.__dfaKtUitLink) {
        var uitLink = ktUitAdres();
        if (uitLink) {
          window.__dfaKtUitLink = true;
          eigenVeld.value = window.DFData.formatPlate(uitLink);
          vorm.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      }
    }

    /* 20-10-2026, laatste autokeuze wint (herstel na review): eerst luisteren,
       dan pas de platen binden. Een kenteken uit de link dat al in het
       sessiegeheugen staat, wordt in bindPlaat meteen (synchroon) onthouden
       en omgeroepen; luisterde volgKenteken dan nog niet, dan werd die auto
       niet de gekozen auto. */
    if (!window.__dfaVolgt) {
      window.__dfaVolgt = true;
      document.addEventListener('df:kenteken', function (e) {
        var d = e && e.detail;
        if (d && d.kt) volgKenteken(d.kt, d.v);
      });
      /* De knop "Passende onderdelen" in de kaart op de homepagina. Op dat
         moment is het kenteken in die kaart de auto van de bezoeker, ook als
         de datalaag niets omriep omdat het kenteken al bekend was. */
      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[data-kt-onderdelen]') : null;
        if (!a) return;
        var r = ktLees();
        if (r && r.kt && r.v) volgKenteken(r.kt, r.v);
      });
    }

    Array.prototype.forEach.call(document.querySelectorAll('form[data-dfa-kt]'), bindPlaat);

    /* ---- onthouden auto tonen ----
       Als functie, want de gekozen auto kan tijdens de pagina veranderen
       (zie volgKenteken hieronder): dan moeten balk, paneel en chip mee. */
    var togTekst = tog.textContent;
    var togTitel = tog.getAttribute('title');
    /* De regel "Je auto: ... wissen" in het paneel (20-10-2026 in een
       functie, zodat hij ook bij alleen een kenteken kan staan). */
    function vulNu(nu, naam) {
      nu.innerHTML = '';
      nu.appendChild(document.createTextNode(nu.getAttribute('data-voor') || T('Je auto:', 'Your car:')));
      var vet = document.createElement('b');
      vet.textContent = naam;
      nu.appendChild(vet);
      var wis = document.createElement('button');
      wis.type = 'button';
      wis.textContent = nu.getAttribute('data-wis') || T('wissen', 'clear');
      wis.addEventListener('click', function () {
        try { localStorage.removeItem(SLEUTEL); } catch (e) {}
        try { localStorage.removeItem(KT_SLEUTEL); } catch (e) {}
        try { sessionStorage.removeItem(KT_SLEUTEL); } catch (e) {}
        try { sessionStorage.removeItem('df_kt_laatste'); } catch (e) {}
        try { sessionStorage.removeItem('df_kt_geheugen'); } catch (e) {}
        window.location.reload();
      });
      nu.appendChild(wis);
      nu.hidden = false;
    }
    function toonAuto() {
      var auto = gekozen();
      var oudeChip = document.querySelector('[data-dfa-chip]');
      if (oudeChip) {
        var oudeGrp = oudeChip.closest('.df-sf__grp') || oudeChip;
        if (oudeGrp.parentNode) oudeGrp.parentNode.removeChild(oudeGrp);
      }
      if (!auto || !auto.url || !auto.label) {
        /* Geen of niet langer een gekozen auto: alles terug naar de beginstand. */
        tog.textContent = togTekst;
        tog.classList.remove('ftog--auto');
        if (togTitel) tog.setAttribute('title', togTitel); else tog.removeAttribute('title');
        var leeg = paneel.querySelector('[data-dfa-nu]');
        if (leeg) { leeg.innerHTML = ''; leeg.hidden = true; }
        /* 20-10-2026, laatste autokeuze wint (herstel na review): alleen een
           kenteken (meerdere uitvoeringen, of een auto zonder collectie)?
           Dan noemt de productpagina die auto, dus hier moet hij ook te
           wissen zijn. */
        var k = ktLees();
        if (leeg && k && k.kt) {
          var kv = k.v || k.auto;
          var kNaam = kv && (kv.merk || kv.model) ? [kv.merk, kv.model].filter(Boolean).join(' ') + (kv.bouwjaar ? ', ' + kv.bouwjaar : '') : ((window.DFData && window.DFData.formatPlate) ? window.DFData.formatPlate(k.kt) : k.kt);
          vulNu(leeg, kNaam);
        }
        return;
      }
      var naam = auto.merk ? auto.merk + ' ' + auto.label : auto.label;

      /* Een kort vast label in de balk, niet de naam van de auto. De menubalk
         zit namelijk al vol zonder auto: de zes menu-items plus "Kies je auto"
         vullen de strook tot op drie pixels na, en .lnk is een schuifstrook met
         een verborgen schuifbalk. Zet je daar een autonaam neer, dan schuiven
         Detailing en Over ons stilletjes uit beeld zonder dat iemand ziet dat
         er nog iets staat. De mediane autonaam is 117px tegen 74px voor "Kies
         je auto", dus dat gaat altijd mis. De volledige naam staat in het
         paneel zelf, in de tooltip en in de chip op de shoppagina. */
      tog.textContent = tog.getAttribute('data-auto-label') || T('Jouw auto', 'Your car');
      tog.classList.add('ftog--auto');
      tog.setAttribute('title', naam + T(', klik om te wijzigen', ', click to change'));
      zetVoor(auto.merk, auto.groep, auto.url);

      var nu = paneel.querySelector('[data-dfa-nu]');
      if (nu) vulNu(nu, naam);

      /* Een chip vooraan de balk op de shoppagina, zodat je vanaf elke
         collectie in een klik terug bent bij je eigen auto. Dit kan niet in
         Liquid: de auto staat in localStorage en de server weet er niets van.
         De opmaak komt uit df-shopfilter, want het is dezelfde soort chip. */
      var bar = document.querySelector('[class*="df-sf-"] .df-sf__bar');
      if (bar && !bar.querySelector('[data-dfa-chip]')) {
        var grp = document.createElement('div');
        grp.className = 'df-sf__grp';
        var lbl = document.createElement('em');
        lbl.textContent = T('Jouw auto', 'Your car');
        grp.appendChild(lbl);
        var chip = document.createElement('a');
        chip.className = 'df-sf__chip';
        chip.setAttribute('data-dfa-chip', '');
        chip.href = lokaal(auto.url);
        chip.textContent = naam;
        if (window.location.pathname === lokaal(auto.url)) {
          chip.classList.add('on');
          chip.setAttribute('aria-current', 'page');
        }
        grp.appendChild(chip);
        bar.insertBefore(grp, bar.firstChild);
      }
    }
    afstemmen();
    toonAuto();

    /* Elke wijziging van de keuze (hier, in een ander tabblad, na de
       terugknop) tekent menu, paneel, chip en de regel "Je auto" in de kop
       van de shop opnieuw (20-10-2026). */
    if (!window.__dfaAutoVolgt) {
      window.__dfaAutoVolgt = true;
      document.addEventListener('df:auto', function () {
        toonAuto();
        Array.prototype.forEach.call(document.querySelectorAll('form[data-dfa-kt]'), function (f) {
          if (typeof f.__dfaMijn === 'function') f.__dfaMijn();
        });
      });
    }

    /* ---- de gekozen auto volgt het kenteken (16-10-2026) ----
       Er zijn twee geheugens: het laatste kenteken (df_kenteken, in de
       datalaag) en de gekozen auto (df_auto, hier). Die tweede werd alleen
       gezet bij een klik in de kiezer en nooit bijgewerkt als er ergens
       anders een nieuw kenteken werd opgezocht. Luuk: kenteken op home,
       "Passende onderdelen", en op de collectiepagina stond nog "Je auto"
       met de Tesla van een eerdere keuze. Nu wordt de gekozen auto bij een
       kenteken dat niet bij hem hoort de auto van dat kenteken, als de
       herkenning zeker is, en anders leeg. De datalaag roept elk kenteken om
       met df:kenteken, eerst zonder antwoord (bij het begin van een
       opvraging) en daarna met; na een mislukte opvraging blijft de keuze
       dus leeg. Liever geen auto dan een verkeerde. */
    /* 20-10-2026, laatste autokeuze wint: df-data.js haalt een zelf gekozen
       auto al weg zodra er een ander kenteken binnenkomt; hier komt de auto
       van dat kenteken ervoor in de plaats. Daarna altijd df:auto, zodat
       ook de regel Jouw auto op de productpagina meeloopt. */
    function volgKenteken(kt, v) {
      var net = (window.DFData && window.DFData.formatPlate) ? window.DFData.formatPlate(kt) : kt;
      if (!net) return;
      var auto = lees();
      if (auto && auto.kenteken === net) return;
      var nieuw = null;
      if (v && (v.merk || v.model)) {
        var res = herken(v);
        if (res && res.niveau === 'zeker' && res.item) {
          nieuw = { merk: res.merk, groep: res.groep, label: res.item.l, url: res.item.u, kenteken: net };
        }
      }
      if (nieuw) bewaar(nieuw);
      else if (auto) { try { localStorage.removeItem(SLEUTEL); } catch (e) {} }
      meld();
    }

    /* Oude geheugens bij het laden in lijn brengen met de regel (20-10-2026).
       - Een keuze met een ander kenteken dan het laatste: het kenteken is
         nieuwer, dus de auto van dat kenteken (of geen).
       - Een keuze zonder kenteken naast een kenteken: met de hand gekozen,
         in de zoekbalk (df-zoekauto.js schrijft df_auto zelf) of in een
         eerdere versie van de site. Hoort hij bij het kenteken, dan krijgt
         hij het kenteken mee; anders vergeten we het kenteken. */
    function afstemmen() {
      var a = lees();
      var k = ruwKt();
      if (!a || !k) return;
      if (a.kenteken) {
        if (ktPlat(a.kenteken) !== ktPlat(k.kt)) volgKenteken(k.kt, k.v || k.auto);
        return;
      }
      if (hoortBij(a.url, k)) {
        a.kenteken = window.DFData && window.DFData.formatPlate ? window.DFData.formatPlate(k.kt) : k.kt;
        bewaar(a);
        /* Het kenteken telt weer: de platen die al leeg bleven vullen zich. */
        meld();
      } else {
        vergeet();
      }
    }

    /* De handmatige motorkiezer op de chiptuningpagina (df-tunekiezer.js via
       df-kenteken.js) is ook een autokeuze. Kiest de bezoeker daar een
       andere auto dan die van het kenteken, dan geldt het kenteken nergens
       meer, en een eerder gekozen auto alleen als het dezelfde is. Valt de
       keuze op precies een modelcollectie, dan wordt dat de gekozen auto;
       anders is er geen gekozen auto. Liever geen auto dan een verkeerde. */
    function kiesMotor(v) {
      if (!v || (!v.merk && !v.model)) return;
      var k = ruwKt();
      var kv = k && (k.v || k.auto);
      if (kv && merkSleutel(kv.merk) === merkSleutel(v.merk) && plat(kv.model) && plat(kv.model) === plat(v.model)) return;
      var res = herken(v);
      var a = lees();
      /* Dezelfde auto als de gekozen auto (de motorkiezer kent geen
         bouwjaar, dus elke generatie van die modelgroep telt): niets te
         veranderen, ook niet aan het kenteken dat erbij hoort. */
      if (a && passend(a.url, res)) return;
      if (res && res.niveau === 'zeker' && res.item) bewaar({ merk: res.merk, groep: res.groep, label: res.item.l, url: res.item.u });
      else if (a) { try { localStorage.removeItem(SLEUTEL); } catch (e) {} }
      if (k) vergeet();
      meld();
    }
    window.DFAuto.kiesMotor = kiesMotor;
    /* Het volgen van df:kenteken staat sinds 20-10-2026 boven het binden van
       de platen, zie daar. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#autokiezer')) start();
  });
})();